var React = require('react');

function Folder (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3 10.5C3 8.016 5.016 6 7.5 6H15c1.415 0 2.75.665 3.6 1.8l3.15 4.2H40.5c2.484 0 4.5 2.016 4.5 4.5v21c0 2.484-2.016 4.5-4.5 4.5h-33A4.501 4.501 0 013 37.5v-27zM7.5 9A1.5 1.5 0 006 10.5v27A1.5 1.5 0 007.5 39h33a1.5 1.5 0 001.5-1.5v-21a1.5 1.5 0 00-1.5-1.5H21a1.5 1.5 0 01-1.2-.6l-3.6-4.8A1.5 1.5 0 0015 9H7.5z"}));
}

Folder.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Folder;

Folder.default = Folder;
